import React, { Component, createRef, useState } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Link, Element } from 'react-scroll'
import { compose } from 'recompose'
import T from 'i18n-react'
import ProjectDetails from './ProjectDetails'
import Divider from './Divider'
import NavDrawer from './NavDrawer'
import Layout from './Layout'
import Panel from './Panel'
import Card from './Card'
import Specifications from './Specifications'
import ScrollNavigation from './ScrollNavigation'
import Subheading from './Subheading'
import SupportTeam from 'containers/Project/SupportTeam/index'
import FileSection from 'containers/Project/FileSection/index'
import GLTSection from 'containers/Project/GreenlightSection/index'
import ScheduleSection from 'containers/Project/ScheduleSection/index'
import ProjectExecutionSection from 'containers/Project/ProjectExecutionSection/index'
import LifecycleSection from 'containers/Project/LifecycleSection/index'
import NvqualSection from 'containers/Project/NvqualSection/index'
import CpmSection from 'containers/Project/CpmSection/index'
import WeeklyUpdateSection from 'containers/Project/WeeklyUpdateSection/index'
import NvbugsSection from 'containers/Project/NvbugsSection/index'
import CancelProjectDialog from 'containers/Project/CancelProjectDialog/index'
import withRevision from 'containers/Project/Revision'
import Header from 'containers/Project/Header'

import dialogHoc from 'containers/Async/AsyncDialog'
import {
  loadFormData,
  getProjectInfo, 
  cloneProject as cloneProjectAction,
  initialize,
  scrollTop
} from './actions'
import {
  mount as mountCancelDialog
} from 'containers/Project/CancelProjectDialog/actions'
import {
  brandSelector,
  productGpuSkuSelector,
  productSkuSelector,
  projectNameSelector,
  partnerSiteNameSelector,
  workflowLifecycleSelector,
  segmentSelector,
  navigationListSelector,
  createdBySelector,
  createdAtSelector,
  riskSelector,
  restrictedSelector,
  architectureSelector,
  productLineSelector,
  productClassSelector,
  customerClassSelector,
  readOnlySelector,
  scrolledTop
} from './selectors'
import { collapseSelector, collapsingSelector } from 'containers/Project/Header/selectors'
import {
  LOAD_PROJECT_FORM,
  LOAD_PROJECT_FORM_DATA
} from 'containers/Project/constants'
import { setSticky } from 'containers/Project/Header/actions'

const mapStateToProps = (state) => {
  return {
    brand: brandSelector(state),
    gpuSku: productGpuSkuSelector(state),
    sku: productSkuSelector(state),
    name: projectNameSelector(state),
    partnerSiteName: partnerSiteNameSelector(state),
    lifecycle: workflowLifecycleSelector(state),
    segment: segmentSelector(state),
    createdBy: createdBySelector(state),
    createdAt: createdAtSelector(state),
    risk: riskSelector(state),
    restricted: restrictedSelector(state),
    architecture: architectureSelector(state),
    productLine: productLineSelector(state),
    productClass: productClassSelector(state),
    customerClass: customerClassSelector(state),
    navigation: navigationListSelector(state),
    scrolledTop: scrolledTop(state),
    collapse: collapseSelector(state),
    collapsing: collapsingSelector(state),
    readOnly: readOnlySelector(state)
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    getProjectInfo: (id) => dispatch(getProjectInfo(id)),
    loadFormData: (id) => dispatch(loadFormData(id)),
    cloneProject: () => dispatch(cloneProjectAction()),
    cancelProject: () => dispatch(mountCancelDialog()),
    initialize: () => dispatch(initialize()),
    scrollTopAction: (isTop) => dispatch(scrollTop(isTop)),
    setSticky: (sticky) => dispatch(setSticky(sticky))
  }
}

const AsyncDialog = dialogHoc([
  LOAD_PROJECT_FORM,
  LOAD_PROJECT_FORM_DATA
])

class Index extends Component {

  constructor(props) {
    super(props);
    this.scrollDivRef = createRef();
  }

  componentDidMount() {
    const {
      loadFormData,
      getProjectInfo,
      match,
      initialize,
    } = this.props
    initialize()
    getProjectInfo(match.params.id)
    loadFormData(match.params.id)
  }

  onScroll = (e) => {
    const {
      scrolledTop,
      scrollTopAction,
      collapse,
      setSticky,
    } = this.props
    const top = Math.floor(e.target.scrollTop) < this.scrollDivRef.current.offsetTop

    if (top === scrolledTop) return
    if (collapse !== top) setSticky(collapse)
    scrollTopAction(top)
  }


  render() {
    const {
      brand,
      gpuSku,
      sku,
      name,
      cloneProject,
      cancelProject,
      partnerSiteName,
      lifecycle,
      segment,
      createdBy,
      createdAt,
      risk, 
      restricted,
      readOnly,
      architecture,
      productLine,
      productClass,
      customerClass,
      navigation,
      match
    } = this.props

    return (
      <Layout>
        <NavDrawer>
          <Subheading>
            Navigation
          </Subheading>
          <ScrollNavigation
            offset={0}
            containerId='scrollContainer'
            categories={navigation}
          />
        </NavDrawer>
        <Panel 
          onScroll={this.onScroll}
          header={
          <div>
            <Header
            view
            id={match.params.id}
            sku={sku}
            name={name}
            brand={brand}
            gpuSku={gpuSku}
            segment={segment}
            lifecycle={lifecycle}
            partnerSiteName={partnerSiteName}
            createdBy={createdBy}
            createdAt={createdAt}
            architecture={architecture}
            productClass={productClass}
            customerClass={customerClass}
            productLine={productLine}
            risk={risk}
            restricted={restricted}
            readOnly={readOnly}
          />
          </div>
          }>

          <div ref={this.scrollDivRef}/>
          <Element name='specifications' className='element'>
            <Specifications
              id={match.params.id}
              cloneProject={cloneProject}
              cancelProject={cancelProject}
            />
          </Element>
          <Element name={'project_schedule'} className='element'>
            <ScheduleSection
              id={match.params.id}
            />
          </Element>
          <Element name={'project_execution'} className='element'>
            <ProjectExecutionSection
              id={match.params.id}
            />
          </Element>
          <Element name={'lifecycle'} className='element'>
            <LifecycleSection
              id={match.params.id}
            />
          </Element>
          <Element name={'weekly_updates'} className='element'>
            <WeeklyUpdateSection
              id={match.params.id}
            />
          </Element>
          <Element name={'nvbugs'} className='element'>
            <NvbugsSection
              id={match.params.id}
            />
          </Element>
          <Element name={'nvqual_report'} className='element'>
            <NvqualSection
              id={match.params.id}
            />
          </Element>
          <Element name={'customer_program_management'} className='element'>
            <CpmSection
              id={match.params.id}
            />
          </Element>
          <Element name={'support_team'} className='element'>
            <SupportTeam id={match.params.id}/>
          </Element>
          <Element name={'attachments'} className='element'>
            <FileSection/>
          </Element>
          <Element name={'green_light_report'} className='element'>
            <GLTSection/>
          </Element>
        </Panel>
        <CancelProjectDialog/>
        <AsyncDialog title='Loading Project ...'/>
      </Layout>
    )
  }
}

const withConnect = connect(mapStateToProps, mapDispatchToProps)
const enhance = compose(
  withRevision,
  withConnect
)
export default enhance(Index)

